import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// INJEÇÃO DE SEGURANÇA E AJUSTE DE 1PX
const style = document.createElement('style');
style.innerHTML = `
  /* Garante que o site não inverta no Google (LTR) */
  html, body { 
    direction: ltr !important; 
    margin: 0; 
    padding: 0; 
    overflow-x: hidden !important; 
  }
  
  /* Ajuste da Aba Lateral: Encolhe para cima e para o lado, sobrando 1px */
  /* Aplicamos em classes comuns de menu (ajuste conforme seu código se necessário) */
  .menu-lateral, .sidebar, [class*="Menu"], [class*="Drawer"] { 
    position: fixed !important;
    /* Move para cima deixando 1px: se a altura for 100%, top seria -99.9% */
    top: -99.9% !important; 
    /* Move para a direita deixando 1px: se a largura for 250px, right seria -249px */
    right: -249px !important; 
    left: auto !important; /* Bloqueia o erro de aparecer na esquerda */
    width: 250px !important;
    height: 100vh !important;
    transition: all 0.3s ease-in-out !important;
    z-index: 9999 !important;
  }

  /* Quando o menu é ativado, ele volta para a posição 0,0 */
  .menu-lateral.active, .open, .active {
    top: 0 !important;
    right: 0 !important;
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);